import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import './style.scss';

export class SwitchButton extends Component {

  static propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    checked: PropTypes.bool,
    onCheck: PropTypes.func,
    name: PropTypes.string,
    disabled: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      id: uuidv4(),
      name: props.name,
      checked: props.checked
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      checked: nextProps.checked
    });
  }

  onToggle = () => {
    this.setState({
      checked: !this.state.checked
    }, () => {
      this.props.onCheck(this.state.checked);
    });
  }

  render() {
    return (
      <div
        className={['switch-button', this.props.className ? this.props.className : ''].join(' ')}
        style={this.props.style}>
        <input
          id={`toggly-${this.state.id}`}
          name={this.state.name}
          type='checkbox'
          disabled={this.props.disabled}
          checked={this.state.checked}
          onChange={this.onToggle} />
        <label htmlFor={`toggly-${this.state.id}`} style={this.props.disabled ? {cursor: 'not-allowed'} : {}}><i /></label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/switch-button/index.js